"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nPointsFormatClientProvider = exports.I18nPointsFormatContext = void 0;
var I18nPointsFormatContext_1 = require("./I18nPointsFormatContext");
Object.defineProperty(exports, "I18nPointsFormatContext", { enumerable: true, get: function () { return __importDefault(I18nPointsFormatContext_1).default; } });
var I18nPointsFormatClientProvider_1 = require("./I18nPointsFormatClientProvider");
Object.defineProperty(exports, "I18nPointsFormatClientProvider", { enumerable: true, get: function () { return __importDefault(I18nPointsFormatClientProvider_1).default; } });
